import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {SearchFilter} from '@app/core/services/search/search-filter.interface'

import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {
  DomainService,
  Domain,
  GetDomainsRequest,
} from '@app/core/services/domain/domain.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

export interface DomainRequest extends LoadRequest {
  query: string
  sortField: string
  sortAsc: boolean
}

@Injectable()
export class DomainListService extends GenericListService<Domain> {
  filter: SearchFilter = null

  constructor(
    private domainSvc: DomainService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Domain>> {
    // build the service request
    const svcRequest: GetDomainsRequest = {
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.domainSvc.getDomains(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Domain> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
